import { Translate } from '@dreryk/react-common';
import { Modal, ModalCancelButton, ModalCloseButton, ModalWidth } from '@dreryk/react-components';

import { nfzSettingsTranslationKeys } from '../../../../../translations';

import { EzwmSenderCodeModalConfirmButton } from './EzwmSenderCodeModalConfirmButton';

type EzwmSenderCodeRemoveModalProps = {
   readonly onClose: VoidFunction;
   readonly onRemoveSuccess: VoidFunction;
};

export const EzwmSenderCodeRemoveModal = (props: EzwmSenderCodeRemoveModalProps): JSX.Element => {
   return (
      <Modal testId={'removeSenderCode'} title={nfzSettingsTranslationKeys.removeSenderCode} width={ModalWidth.NORMAL}>
         <Translate>{nfzSettingsTranslationKeys.areYourSureRemovingSenderCode}</Translate>
         <ModalCancelButton onClick={props.onClose} />
         <ModalCloseButton onClick={props.onClose} />
         <EzwmSenderCodeModalConfirmButton onSuccess={props.onRemoveSuccess} />
      </Modal>
   );
};
